import { render, staticRenderFns } from "./PressReleaseInputsForm.vue?vue&type=template&id=1fd92654"
import script from "./PressReleaseInputsForm.vue?vue&type=script&lang=js"
export * from "./PressReleaseInputsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports